import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, WalletIcon, BriefcaseIcon, LineChartIcon, BarChart3Icon, MegaphoneIcon, UsersIcon, BrainCircuitIcon, RocketIcon, CandlestickChartIcon, CurrencyIcon, ShoppingCartIcon, PiggyBankIcon, LightbulbIcon, CrownIcon, HeadsetIcon, TargetIcon, SparklesIcon, HeartIcon, BookOpenIcon, ActivityIcon, SunIcon } from 'lucide-react';
const categories = [{
  name: 'Educación',
  icon: GraduationCapIcon
}, {
  name: 'Finanzas',
  icon: WalletIcon
}, {
  name: 'Negocios',
  icon: BriefcaseIcon
}, {
  name: 'Economía',
  icon: LineChartIcon
}, {
  name: 'Mercados',
  icon: BarChart3Icon
}, {
  name: 'Marketing',
  icon: MegaphoneIcon
}, {
  name: 'Coaching',
  icon: UsersIcon
}, {
  name: 'PNL',
  icon: BrainCircuitIcon
}, {
  name: 'Emprendimiento',
  icon: RocketIcon
}, {
  name: 'Trading',
  icon: CandlestickChartIcon
}, {
  name: 'Forex',
  icon: CurrencyIcon
}, {
  name: 'Ventas',
  icon: ShoppingCartIcon
}, {
  name: 'Inversiones',
  icon: PiggyBankIcon
}, {
  name: 'Innovación',
  icon: LightbulbIcon
}, {
  name: 'Liderazgo',
  icon: CrownIcon
}, {
  name: 'Servicio al Cliente',
  icon: HeadsetIcon
}, {
  name: 'Publicidad',
  icon: TargetIcon
}, {
  name: 'Superación Personal',
  icon: SparklesIcon
}, {
  name: 'Seducción',
  icon: HeartIcon
}, {
  name: 'Dummies',
  icon: BookOpenIcon
}, {
  name: 'Salud',
  icon: ActivityIcon
}, {
  name: 'Vida',
  icon: SunIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function CategoriesGrid() {
  return <section className="py-24 bg-white" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-navy mb-4" data-id="element-13">
            Todo lo Que Te Interesa, Cubierto
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-14">
            Una biblioteca masiva que cubre cada aspecto del desarrollo personal
            y profesional.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-15">
          {categories.map((cat, index) => {
          const Icon = cat.icon;
          return <motion.div key={index} variants={itemVariants} whileHover={{
            y: -5,
            scale: 1.02
          }} className="bg-gray-50 border border-gray-100 rounded-xl p-6 flex flex-col items-center justify-center text-center gap-3 hover:shadow-md hover:border-brand-emerald/30 transition-all cursor-default group" data-id="element-16">
                <div className="bg-white p-3 rounded-full shadow-sm text-brand-navy group-hover:text-brand-emerald group-hover:bg-brand-emerald/10 transition-colors" data-id="element-17">
                  <Icon size={24} data-id="element-18" />
                </div>
                <span className="font-medium text-sm text-gray-800 group-hover:text-brand-navy transition-colors" data-id="element-19">
                  {cat.name}
                </span>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}